import { render, staticRenderFns } from "./StoresSwitcher.vue?vue&type=template&id=2455f528"
import script from "./StoresSwitcher.vue?vue&type=script&lang=ts"
export * from "./StoresSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports